import { useEffect, useRef, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from "@mui/material";
import { handleAxiosError } from "app/services/app.error.handler";
import { updateMemberSingleActivity } from "app/services/member.service";
import * as AppConstants from "AppConstants";
import MDBox from "components/MDBox";
import { trimOnBlur, trimTextFields } from "utils/trimOnBlur";

export const EditActivityDialog = ({
  editOpen,
  setEditOpen,
  rowData,
  refreshActivitiesDataHandler,
}) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    setData(rowData);
  }, [rowData]);

  const updateSingleActivityInBackend = async () => {
    if (!data?.id) {
      return;
    }

    await updateMemberSingleActivity(data.id, trimTextFields(data))
      .then((response) => {
        setEditOpen(false);
        refreshActivitiesDataHandler();
      })
      .catch((error) => {
        handleAxiosError(error);
      });
  };

  return (
    <Dialog open={editOpen} fullWidth={true} maxWidth="sm">
      <DialogTitle>Update Activity</DialogTitle>
      <DialogContent>
        <DialogContentText></DialogContentText>
        <MDBox my={2}>
          <TextField
            autoFocus
            id="hours"
            label="Hours Spent"
            type="number"
            fullWidth
            variant="standard"
            value={data ? data.hoursSpent : ""}
            onChange={(e) => setData({ ...data, hoursSpent: parseInt(e.target.value) })}
          />
        </MDBox>
        <MDBox my={2}>
          <TextField
            id="ticket"
            label="Client Ticket"
            fullWidth
            variant="standard"
            value={data ? data.clientTicketRef : ""}
            onBlur={trimOnBlur(setData, "clientTicketRef")}
            onChange={(e) => setData({ ...data, clientTicketRef: e.target.value })}
          />
        </MDBox>
        <MDBox my={2}>
          <TextField
            id="description"
            label="Description"
            fullWidth
            variant="standard"
            value={data ? data.description : ""}
            onBlur={trimOnBlur(setData, "description")}
            onChange={(e) => setData({ ...data, description: e.target.value })}
          />
        </MDBox>
        <MDBox my={2}>
          <TextField
            select
            // id="Status"
            label="Status"
            id="addActivityStatus"
            helperText="*Required"
            fullWidth
            variant="standard"
            value={data ? data.status : ""}
            onChange={(e) => setData({ ...data, status: e.target.value })}
            SelectProps={{
              native: true,
            }}
          >
            {AppConstants.ACTIVITY_STATUSES.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </TextField>
        </MDBox>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setEditOpen(false)}>Cancel</Button>
        <Button onClick={updateSingleActivityInBackend}>Update</Button>
      </DialogActions>
    </Dialog>
  );
};
